/* Weinmeister Custom */
(function() {
  'use strict';

  function processCard(card) {
    // Skip if already has our custom cart (replaces WeakSet to survive DOM replacement)
    if (card.querySelector('.wm-hover-cart')) return;

    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return;
    var productUrl = link.getAttribute('href').split('?')[0];

    // Fetch product data for subtitle
    fetch(productUrl + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        // SUBTITLE
        var tags = product.tags || [];
        var region = '', produzent = '', flasche = '750 ml';
        tags.forEach(function(t) {
          if (t.indexOf('Region:') === 0) region = t.substring(7);
          if (t.indexOf('Produzent:') === 0) produzent = t.substring(10);
          if (t.indexOf('Flasche:') === 0) flasche = t.substring(8);
        });
        if (region || produzent) {
          var parts = [];
          if (region) parts.push(region);
          if (produzent) parts.push(produzent);
          parts.push(flasche);
          var sub = document.createElement('p');
          sub.className = 'wm-subtitle';
          sub.style.cssText = 'font-size:13px;color:#888;margin:2px 0 4px;line-height:1.4;';
          sub.textContent = parts.join(', ');
          // Insert after the title anchor
          var titleAnchor = card.querySelector('a.contents.user-select-text');
          if (titleAnchor) {
            titleAnchor.parentNode.insertBefore(sub, titleAnchor.nextSibling);
          }
        }

        // PARKER BADGE
        var parkerTag = (product.tags || []).find(function(t) { return t.indexOf('Parker:') === 0; });
        if (parkerTag && !card.querySelector('.wm-parker-badge')) {
          var score = parkerTag.substring(7);
          var badge = document.createElement('div');
          badge.className = 'wm-parker-badge';
          badge.innerHTML = '<span class="wm-parker-badge__label">PARKER</span>' +
            '<span class="wm-parker-badge__score">' + score + '</span>' +
            '<span class="wm-parker-badge__suffix">PUNKTE</span>';
          // Insert in the image area
          var gallery = card.querySelector('[class*="card-gallery"], [class*="resource-image"], .product-card-gallery__image-wrapper');
          if (gallery) {
            gallery.style.position = 'relative';
            gallery.appendChild(badge);
          } else {
            card.style.position = 'relative';
            card.appendChild(badge);
          }
        }

        // VINUM BADGE
        var vinumTag = (product.tags || []).find(function(t) { return t.indexOf('Vinum:') === 0; });
        if (vinumTag && !card.querySelector('.wm-vinum-badge')) {
          var vScore = vinumTag.substring(6);
          var vBadge = document.createElement('div');
          vBadge.className = 'wm-vinum-badge';
          vBadge.innerHTML = '<span class="wm-vinum-badge__label">vinum</span>' +
            '<span class="wm-vinum-badge__score">' + vScore + '</span>' +
            '<span class="wm-vinum-badge__suffix">PUNKTE</span>';
          var vGallery = card.querySelector('[class*="card-gallery"], [class*="resource-image"], .product-card-gallery__image-wrapper');
          if (vGallery) {
            vGallery.style.position = 'relative';
            vGallery.appendChild(vBadge);
          }
        }
      })
      .catch(function() {});

    // HOVER CART
    var wrap = document.createElement('div');
    wrap.className = 'wm-hover-cart';

    var qtyWrap = document.createElement('div');
    qtyWrap.className = 'wm-qty-wrapper';
    var minus = document.createElement('button');
    minus.type = 'button'; minus.className = 'wm-qty-btn'; minus.textContent = '\u2212';
    var input = document.createElement('input');
    input.type = 'number'; input.className = 'wm-qty-input'; input.value = '1'; input.min = '1'; input.max = '99';
    var plus = document.createElement('button');
    plus.type = 'button'; plus.className = 'wm-qty-btn'; plus.textContent = '+';
    qtyWrap.appendChild(minus); qtyWrap.appendChild(input); qtyWrap.appendChild(plus);

    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'wm-add-btn';
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45C5.09 14.32 5 14.65 5 15c0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1 1 0 0020.01 4H5.21l-.94-2H1zm16 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg> In den Warenkorb';
    wrap.appendChild(qtyWrap); wrap.appendChild(btn);

    minus.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); var v = parseInt(input.value) || 1; if (v > 1) input.value = String(v - 1); });
    plus.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); input.value = String((parseInt(input.value) || 1) + 1); });

    var origHTML = btn.innerHTML;
    btn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation();
      var qty = parseInt(input.value) || 1;
      btn.textContent = '...'; btn.disabled = true;
      fetch(productUrl + '.js').then(function(r) { return r.json(); }).then(function(p) {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: p.variants[0].id, quantity: qty }] }) });
      }).then(function() {
        btn.innerHTML = '\u2713 Hinzugef\u00fcgt';
        setTimeout(function() { btn.innerHTML = origHTML; btn.disabled = false; }, 1500);
      }).catch(function() {
        btn.textContent = 'Fehler';
        setTimeout(function() { btn.innerHTML = origHTML; btn.disabled = false; }, 1500);
      });
    });

    // Hide native quick-add button (done here so it's only hidden after our cart is ready)
    var nativeQA = card.querySelector('.quick-add');
    if (nativeQA) nativeQA.style.display = 'none';

    // Append to the product-card__content div
    var content = card.querySelector('[class*="product-card__content"]');
    if (content) { content.appendChild(wrap); }
    else { card.appendChild(wrap); }
  }

  function boot() {
    // Clean duplicates from previous loads
    document.querySelectorAll('product-card').forEach(function(card) {
      var carts = card.querySelectorAll('.wm-hover-cart');
      for (var i = 1; i < carts.length; i++) carts[i].remove();
      var subs = card.querySelectorAll('.wm-subtitle');
      for (var j = 1; j < subs.length; j++) subs[j].remove();
      // Fix orphaned state: native QA hidden but no custom cart
      if (!card.querySelector('.wm-hover-cart')) {
        var nativeQA = card.querySelector('.quick-add');
        if (nativeQA && nativeQA.style.display === 'none') {
          nativeQA.style.display = '';
        }
      }
    });
    document.querySelectorAll('product-card').forEach(processCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(boot, 500); });
  } else { setTimeout(boot, 500); }

  var bootTimer = null;
  new MutationObserver(function(mutations) {
    var dominated = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) { dominated = true; break; }
    }
    if (dominated) {
      clearTimeout(bootTimer);
      bootTimer = setTimeout(boot, 400);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();

/* Weinmeister - Auto-close filter dropdowns after selection */
(function() {
  'use strict';

  var pendingClose = false;

  /* On checkbox change, set flag and close the panel */
  document.addEventListener('change', function(e) {
    var checkbox = e.target;
    if (!checkbox || checkbox.type !== 'checkbox') return;
    var details = checkbox.closest('details.facets__panel');
    if (!details) return;
    if (details.closest('.facets--drawer') || details.closest('[class*="drawer"]')) return;
    pendingClose = true;
    details.removeAttribute('open');
  }, true);

  /* After AJAX reload, theme re-renders with open panels. Close them. */
  new MutationObserver(function() {
    if (!pendingClose) return;
    setTimeout(function() {
      var panels = document.querySelectorAll('.facets--horizontal details.facets__panel[open], .facets__overflow-list details.facets__panel[open]');
      if (panels.length > 0) {
        panels.forEach(function(d) { d.removeAttribute('open'); });
        pendingClose = false;
      }
    }, 100);
  }).observe(document.body, { childList: true, subtree: true });

  /* Collapse all drawer filter details when drawer opens */
  var drawer = document.querySelector('.facets--drawer');
  if (drawer) {
    new MutationObserver(function() {
      if (drawer.hasAttribute('open')) {
        drawer.querySelectorAll('details.facets__panel[open]').forEach(function(d) {
          d.removeAttribute('open');
        });
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
    /* Also collapse on initial load */
    drawer.querySelectorAll('details.facets__panel[open]').forEach(function(d) {
      d.removeAttribute('open');
    });
  }
})();



/* Weinmeister - Replace "Mehr" with "Weitere Filter" + icon */
(function() {
  'use strict';
  var sliderIcon = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6ab04c" stroke-width="2" stroke-linecap="round" style="vertical-align:middle;margin-right:6px"><line x1="4" y1="6" x2="20" y2="6"/><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="18" x2="20" y2="18"/><circle cx="8" cy="6" r="2" fill="#6ab04c"/><circle cx="16" cy="12" r="2" fill="#6ab04c"/><circle cx="10" cy="18" r="2" fill="#6ab04c"/></svg>';

  function replaceMehrButton() {
    document.querySelectorAll('.menu-list__link-title').forEach(function(span) {
      if (span.textContent.trim() === 'Mehr') {
        span.innerHTML = sliderIcon + 'Weitere Filter';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(replaceMehrButton, 300); });
  } else { setTimeout(replaceMehrButton, 300); }
  new MutationObserver(function() { setTimeout(replaceMehrButton, 200); }).observe(document.body, { childList: true, subtree: true });
})();

/* Weinmeister - Speiseempfehlung banners + titles */
(function() {
  'use strict';
  var speiseData = {
    'Aperitif': { title: 'Aperitif', img: 'https://images.unsplash.com/photo-1470337458703-46ad1756a187?w=1400&h=400&fit=crop&q=80&crop=center' },
    'Fisch': { title: 'Fisch', img: 'https://images.unsplash.com/photo-1534604973900-c43ab4c2e0ab?w=1400&h=400&fit=crop&q=80&crop=center' },
    'Meeresfruechte': { title: 'Meeresfr\u00fcchte', img: 'https://images.unsplash.com/photo-1565680018434-b513d5e5fd47?w=1400&h=400&fit=crop&q=80&crop=center' },
    'Pasta': { title: 'Pasta', img: 'https://images.unsplash.com/photo-1556761223-4c4282c73f77?w=1400&h=400&fit=crop&q=80&crop=center' },
    'Vegetarisch': { title: 'Vegetarisch', img: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=1400&h=400&fit=crop&q=80&crop=center' },
    'Exotisch': { title: 'Exotische K\u00fcche', img: 'https://images.unsplash.com/photo-1455619452474-d2be8b1e70cd?w=1400&h=400&fit=crop&q=80&crop=center' },
    'Gefluegel': { title: 'Gefl\u00fcgel', img: 'https://images.unsplash.com/photo-1598515214211-89d3c73ae83b?w=1400&h=400&fit=crop&q=80&crop=center' },
    'Schwein': { title: 'Schwein', img: 'https://images.unsplash.com/photo-1432139555190-58524dae6a55?w=1400&h=400&fit=crop&q=80&crop=center' },
    'Rind': { title: 'Rind', img: 'https://images.unsplash.com/photo-1546964124-0cce460f38ef?w=1400&h=400&fit=crop&q=80&crop=center' },
    'Grillsaison': { title: 'Grillsaison', img: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=1400&h=400&fit=crop&q=80&crop=center' },
    'Kaese': { title: 'K\u00e4se', img: 'https://images.unsplash.com/photo-1452195100486-9cc805987862?w=1400&h=400&fit=crop&q=80&crop=center' },
    'Dessert': { title: 'Dessert', img: 'https://images.unsplash.com/photo-1488477181946-6428a0291777?w=1400&h=400&fit=crop&q=80&crop=center' }
  };

  function addSpeiseBanner() {
    var params = new URLSearchParams(window.location.search);
    var filter = params.get('filter');
    if (!filter || !speiseData[filter]) return;
    if (document.querySelector('.wm-speise-banner')) return;

    var info = speiseData[filter];

    /* Replace heading */
    var heading = document.querySelector('h1');
    if (heading && (heading.textContent.trim() === 'Produkte' || heading.textContent.trim() === 'All')) {
      heading.style.display = 'none';
    }

    /* Create banner */
    var banner = document.createElement('div');
    banner.className = 'wm-speise-banner';
    banner.style.cssText = 'position:relative;width:100%;height:250px;margin-bottom:20px;border-radius:0;overflow:hidden;display:flex;align-items:center;justify-content:center;';
    banner.innerHTML = '<img src="' + info.img + '" alt="' + info.title + '" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;">' +
      '<div style="position:absolute;inset:0;background:rgba(0,0,0,0.35);"></div>' +
      '<h1 style="position:relative;color:#fff;font-size:48px;font-weight:700;letter-spacing:1px;text-shadow:0 2px 8px rgba(0,0,0,0.3);margin:0;">' + info.title + '</h1>';

    /* Insert before the filter bar */
    var main = document.querySelector('main, .collection') || document.querySelector('[class*="collection"]');
    if (main) {
      main.insertBefore(banner, main.firstChild);
    } else {
      var h1 = document.querySelector('h1');
      if (h1 && h1.parentElement) {
        h1.parentElement.insertBefore(banner, h1);
      }
    }

    document.title = info.title + ' \u2013 Weinmeister';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addSpeiseBanner);
  } else {
    addSpeiseBanner();
  }
  new MutationObserver(function() { setTimeout(addSpeiseBanner, 200); }).observe(document.body, { childList: true, subtree: true });
})();

/* Weinmeister - Replace text logo with SVG image */
(function() {
  'use strict';
  function replaceLogo() {
    var spans = document.querySelectorAll('.header-logo__image-container');
    spans.forEach(function(span) {
      if (span.textContent.trim() === 'Weinmeister' && !span.querySelector('img')) {
        var img = document.createElement('img');
        img.alt = 'Weinmeister';
        img.style.cssText = 'height:56px;width:auto;';
        var cssLink = document.querySelector('link[href*="quick-add.css"]');
        if (cssLink) {
          var base = cssLink.href.split('/assets/')[0] + '/assets/';
          img.src = base + 'weinmeister-logo.svg';
        }
        span.textContent = '';
        span.appendChild(img);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceLogo);
  } else { replaceLogo(); }
  new MutationObserver(function() { setTimeout(replaceLogo, 200); }).observe(document.body, { childList: true, subtree: true });
})();

/* Weinmeister - Display marketing text on PDP */
(function() {
  'use strict';
  function showMarketingText() {
    var script = document.getElementById('wm-marketing-text');
    if (!script) return;
    if (document.getElementById('wm-mt-block')) return; /* already rendered */

    var data;
    try { data = JSON.parse(script.textContent); } catch(e) { return; }
    if (!data || (!data.title && (!data.bullets || data.bullets.length === 0))) return;

    /* Build the HTML */
    var container = document.createElement('div');
    container.id = 'wm-mt-block';
    container.style.cssText = 'margin:16px 0 20px;padding:20px 24px;border-left:3px solid #5a7a3a;background:#f9f9f6;border-radius:4px;';

    if (data.title) {
      var h3 = document.createElement('h3');
      h3.textContent = decodeEntities(data.title);
      h3.style.cssText = 'margin:0 0 10px;font-size:16px;font-weight:700;color:#333;';
      container.appendChild(h3);
    }

    if (data.bullets && data.bullets.length > 0) {
      var ul = document.createElement('ul');
      ul.style.cssText = 'margin:0;padding:0 0 0 18px;list-style:disc;';
      data.bullets.forEach(function(b) {
        var li = document.createElement('li');
        li.textContent = decodeEntities(b);
        li.style.cssText = 'margin:0 0 6px;font-size:14px;line-height:1.5;color:#555;';
        ul.appendChild(li);
      });
      container.appendChild(ul);
    }

    /* Find the right place to insert: after price, before add-to-cart */
    var priceEl = document.querySelector('product-price');
    if (priceEl) {
      priceEl.parentElement.insertBefore(container, priceEl.nextSibling);
        /* Hide duplicate body_html description below button */
        setTimeout(function() {
          var allBlocks = document.querySelectorAll('.rte, .product__description');
          allBlocks.forEach(function(el) {
            if (el.id === 'wm-mt-block') return;
            if (el.contains(container)) return;
            var t = el.textContent || '';
            if (data.title && t.includes(data.title.substring(0, 20))) {
              el.closest('[class*="group-block"]') ? el.closest('[class*="group-block"]').style.display = 'none' : el.style.display = 'none';
            }
          });
        }, 100);
    } else {
      /* Fallback: after h1 */
      var h1 = document.querySelector('h1');
      if (h1) {
        var infoBlock = h1.closest('.group-block-content') || h1.parentElement;
        infoBlock.appendChild(container);
      }
    }
  }

  function decodeEntities(str) {
    var el = document.createElement('textarea');
    el.innerHTML = str;
    return el.value;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showMarketingText);
  } else { showMarketingText(); }
})();
/* Hide duplicate body_html when marketing text is present */
(function() {
  function hideDuplicateDesc() {
    var mtBlock = document.getElementById('wm-mt-block');
    if (!mtBlock) return;
    var gbc = document.querySelector('.product-details .group-block-content');
    if (!gbc) return;
    var children = gbc.children;
    for (var i = 0; i < children.length; i++) {
      var el = children[i];
      if (el.id === 'wm-mt-block') continue;
      if (el.tagName === 'SPAN' || el.classList.contains('buy-buttons-block')) continue;
      if (el.classList.contains('view-product-title')) continue;
      if (el.classList.contains('group-block')) continue;
      if (el.classList.contains('divider')) continue;
      var text = (el.textContent || '').trim();
      if (text.indexOf('**') === 0 && text.length > 20) {
        el.style.display = 'none';
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(hideDuplicateDesc, 500); });
  } else { setTimeout(hideDuplicateDesc, 500); }
})();
/* Weinmeister - Filter Redesign: Expandable Rows */
(function() {
  'use strict';

  var PRIMARY_COUNT = 5;
  var STORAGE_KEY = 'wm-facets-expanded';
  var TOGGLE_ICON = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="4" y1="6" x2="20" y2="6"/><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="18" x2="20" y2="18"/><circle cx="8" cy="6" r="2" fill="currentColor"/><circle cx="16" cy="12" r="2" fill="currentColor"/><circle cx="10" cy="18" r="2" fill="currentColor"/></svg>';

  /* ---- Overflow-list neutralisation ---- */

  function neutraliseOverflowList(ol) {
    /* Disable the component's reflow logic */
    try { ol.setAttribute('disabled', 'true'); } catch(e) {}

    /* Clear any slot="overflow" assignments */
    for (var i = 0; i < ol.children.length; i++) {
      if (ol.children[i].slot === 'overflow') {
        ol.children[i].removeAttribute('slot');
      }
    }

    /* Guard against the component re-setting slot="overflow" */
    new MutationObserver(function(muts) {
      for (var m = 0; m < muts.length; m++) {
        if (muts[m].attributeName === 'slot' && muts[m].target.slot === 'overflow') {
          muts[m].target.removeAttribute('slot');
        }
      }
    }).observe(ol, { attributes: true, attributeFilter: ['slot'], subtree: true });

    /* Override shadow DOM internals */
    if (ol.shadowRoot) {
      var sr = ol.shadowRoot;
      var moreSlot = sr.querySelector('slot[name="more"]');
      if (moreSlot) moreSlot.hidden = true;
      var ph = sr.querySelector('[part="placeholder"]');
      if (ph) ph.hidden = true;
      var list = sr.querySelector('[part="list"]');
      if (list) list.style.cssText = 'flex-wrap:wrap!important;height:auto!important;overflow:visible!important;';
      var ovf = sr.querySelector('[part="overflow"]');
      if (ovf) ovf.style.display = 'none';
    }
  }

  /* ---- Expand / Collapse ---- */

  function setExpanded(grid, actionsCol, toggleBtn, expanded) {
    if (expanded) {
      grid.classList.add('wm-expanded');
      actionsCol.classList.add('wm-is-expanded');
      toggleBtn.innerHTML = TOGGLE_ICON + ' Filter schliessen';
      try { sessionStorage.setItem(STORAGE_KEY, 'true'); } catch(e) {}
    } else {
      grid.classList.remove('wm-expanded');
      actionsCol.classList.remove('wm-is-expanded');
      toggleBtn.innerHTML = TOGGLE_ICON + ' Weitere Filter';
      try { sessionStorage.setItem(STORAGE_KEY, 'false'); } catch(e) {}
    }
  }

  /* ---- Collect filter elements from overflow-list ---- */

  function collectFilters(overflowList) {
    var filters = [];
    for (var i = 0; i < overflowList.children.length; i++) {
      var tag = overflowList.children[i].tagName;
      if (tag && tag.toLowerCase() !== 'template') {
        filters.push(overflowList.children[i]);
      }
    }
    return filters;
  }

  /* ---- Build the grid layout ---- */

  function initFilterRedesign() {
    if (window.innerWidth < 750) return;

    var overflowList = document.querySelector('overflow-list.facets__overflow-list');
    if (!overflowList) return;

    /* Already processed? */
    if (overflowList.hasAttribute('data-wm-v3')) return;
    overflowList.setAttribute('data-wm-v3', '');

    neutraliseOverflowList(overflowList);

    var filters = collectFilters(overflowList);
    if (filters.length === 0) return;

    var form = overflowList.closest('.facets__form');
    var filtersWrapper = overflowList.closest('.facets__filters-wrapper');
    if (!form || !filtersWrapper) return;

    /* ---- 1. Build the 5-column filter grid ---- */
    var filtersGrid = document.createElement('div');
    filtersGrid.className = 'wm-filters-grid';
    filtersGrid.id = 'wm-filters-grid';

    for (var i = 0; i < filters.length; i++) {
      var el = filters[i];
      if (i >= PRIMARY_COUNT) {
        el.classList.add('wm-filter-extra');
      }
      filtersGrid.appendChild(el);
    }

    /* ---- 2. Build the actions column ---- */
    var actionsCol = document.createElement('div');
    actionsCol.className = 'wm-actions-col';

    var toggleBtn = document.createElement('button');
    toggleBtn.type = 'button';
    toggleBtn.className = 'wm-toggle-btn';
    toggleBtn.innerHTML = TOGGLE_ICON + ' Weitere Filter';
    toggleBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var isExp = filtersGrid.classList.contains('wm-expanded');
      setExpanded(filtersGrid, actionsCol, toggleBtn, !isExp);
    });
    actionsCol.appendChild(toggleBtn);

    var resetBtn = document.createElement('button');
    resetBtn.type = 'button';
    resetBtn.className = 'wm-reset-btn';
    resetBtn.innerHTML = '\u2715 Auswahl aufheben';
    resetBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      /* Navigate to the collection URL without filter params */
      var url = new URL(window.location.href);
      var keysToDelete = [];
      url.searchParams.forEach(function(val, key) {
        if (key.startsWith('filter.')) keysToDelete.push(key);
      });
      if (keysToDelete.length > 0) {
        keysToDelete.forEach(function(key) { url.searchParams.delete(key); });
        window.location.href = url.toString();
      }
    });
    actionsCol.appendChild(resetBtn);

    /* Only show toggle if there are extra filters */
    if (filters.length <= PRIMARY_COUNT) {
      actionsCol.style.display = 'none';
    }

    /* ---- 3. Build sort area ---- */
    var sortArea = document.createElement('div');
    sortArea.className = 'wm-sort-area';

    /* Move the existing sort component into our sort area */
    var sortEl = form.querySelector('.sorting-filter__horizontal, .sorting-filter, sorting-filter-component');
    if (sortEl) {
      sortArea.appendChild(sortEl);
    }

    /* ---- 4. Assemble the grid layout ---- */
    var gridLayout = document.createElement('div');
    gridLayout.className = 'wm-grid-layout';
    gridLayout.appendChild(filtersGrid);
    gridLayout.appendChild(actionsCol);
    gridLayout.appendChild(sortArea);

    /* Insert the new layout before the original filters wrapper */
    form.insertBefore(gridLayout, form.firstChild);

    /* Mark the form as restructured */
    form.classList.add('wm-v3-restructured');

    /* Visually hide the original filters wrapper (keep in DOM for form submissions) */
    filtersWrapper.classList.add('wm-v3-hidden');

    /* ---- 5. Determine initial state ---- */
    var stored = null;
    try { stored = sessionStorage.getItem(STORAGE_KEY); } catch(e) {}

    var shouldExpand = false;
    if (stored === 'true') {
      shouldExpand = true;
    } else if (stored === null) {
      /* Auto-expand if any secondary filter is active */
      var extras = filtersGrid.querySelectorAll('.wm-filter-extra');
      for (var k = 0; k < extras.length; k++) {
        var checked = extras[k].querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked');
        if (checked.length > 0) { shouldExpand = true; break; }
        var numInputs = extras[k].querySelectorAll('input[type="number"]');
        for (var n = 0; n < numInputs.length; n++) {
          if (numInputs[n].value && numInputs[n].value !== '' && numInputs[n].value !== '0') {
            shouldExpand = true; break;
          }
        }
        if (shouldExpand) break;
      }
    }

    if (shouldExpand) {
      setExpanded(filtersGrid, actionsCol, toggleBtn, true);
    }
  }

  /* ---- Bootstrap ---- */

  function tryInit() { setTimeout(initFilterRedesign, 600); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }

  /* Re-run after AJAX section replacements */
  var redesignTimer = null;
  new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) {
        clearTimeout(redesignTimer);
        redesignTimer = setTimeout(initFilterRedesign, 500);
        return;
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
/* Weinmeister - Poinz Cashback Badge */
(function() {
  'use strict';

  var POINZ_KEY = 'wm-poinz-session';
  var COIN_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"/><path d="M12 18V6"/></svg>';

  /* ---- 1. Detect Poinz referral ---- */

  function isPoinzSession() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('ref') === 'poinz' ||
          params.get('utm_source') === 'poinz' ||
          params.get('poinz') !== null) {
        sessionStorage.setItem(POINZ_KEY, 'true');
        return true;
      }
    } catch(e) {}

    try {
      return sessionStorage.getItem(POINZ_KEY) === 'true';
    } catch(e) {}

    return false;
  }

  /* ---- 2. Create badge elements ---- */

  function createCardBadge(pct) {
    var badge = document.createElement('div');
    badge.className = 'wm-cashback-badge';
    badge.innerHTML = COIN_ICON + ' ' + pct + '% Cashback';
    return badge;
  }

  function createPdpBadge(pct) {
    var badge = document.createElement('div');
    badge.className = 'wm-cashback-pdp';
    badge.innerHTML = COIN_ICON + ' <span>' + pct + '% Cashback</span><span class="wm-cashback-subtext">via Poinz</span>';
    return badge;
  }

  /* ---- 3. Add badges to product cards (collection pages) ---- */
  /* Reads data-cashback attribute rendered by Liquid on <product-card> */

  function addCardBadges() {
    var cards = document.querySelectorAll('product-card[data-cashback]');

    cards.forEach(function(card) {
      if (card.hasAttribute('data-wm-cb-done')) return;
      card.setAttribute('data-wm-cb-done', '');

      var pct = parseInt(card.getAttribute('data-cashback'));
      if (!pct || pct <= 0) return;

      /* Place badge on the image area */
      var imgArea = card.querySelector('.product-card__image, .product-card__media, [class*="product-card__image"]');
      var target = imgArea || card;
      target.style.position = 'relative';
      target.appendChild(createCardBadge(pct));
    });
  }

  /* ---- 4. Add badge to PDP ---- */
  /* Reads data-cashback from a hidden div rendered by Liquid */

  function addPdpBadge() {
    if (!window.location.pathname.includes('/products/')) return;
    if (document.querySelector('.wm-cashback-pdp')) return;

    var dataEl = document.getElementById('wm-cashback-data');
    if (!dataEl) return;

    var pct = parseInt(dataEl.getAttribute('data-cashback'));
    if (!pct || pct <= 0) return;

    /* Find the price area on PDP */
    var priceEl = document.querySelector(
      '.product-price, .price, [class*="price"]:not(input):not(script)'
    );
    if (priceEl) {
      priceEl.parentNode.insertBefore(createPdpBadge(pct), priceEl.nextSibling);
    }
  }

  /* ---- 5. Add top banner ---- */

  function addPoinzBanner() {
    if (document.querySelector('.wm-poinz-banner')) return;

    var banner = document.createElement('div');
    banner.className = 'wm-poinz-banner';
    banner.innerHTML = COIN_ICON + ' <strong>Poinz Cashback aktiv!</strong> Sammle bei jedem Einkauf Cashback direkt auf dein Poinz-Konto.';

    var header = document.querySelector('header, .header, .shopify-section-header, #shopify-section-header');
    if (header) {
      header.parentNode.insertBefore(banner, header);
    } else {
      document.body.insertBefore(banner, document.body.firstChild);
    }
  }

  /* ---- 6. Main init ---- */

  function initCashback() {
    if (!isPoinzSession()) return;

    addPoinzBanner();
    addCardBadges();
    addPdpBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initCashback, 800);
    });
  } else {
    setTimeout(initCashback, 800);
  }

  /* Re-run after AJAX (filter changes, pagination, etc.) */
  var cbTimer = null;
  new MutationObserver(function(mutations) {
    if (!isPoinzSession()) return;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) {
        clearTimeout(cbTimer);
        cbTimer = setTimeout(function() {
          addCardBadges();
          addPdpBadge();
        }, 600);
        return;
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
